import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContentAction from '../shared/ContentAction';
import './ProductDetailPage.css';

export default function ProductDetailLayout({ product, children }) {
  const { t } = useTranslation('app');
  const copy = key => t(`productIntro.${product.translationId}.${key}`);
  useEffect(() => { document.title = 'Hi-Portal'; }, []);
  return (
    <main className={`hicps-page ${product.className || ''}`}>
      <section className="hilink-header">
        <div className="hicps-container hilink-header-inner"><h1>{product.name}</h1></div>
        <div className="hicps-container hilink-header-copy">
          <h2>{copy('hero.title')}</h2>
          <p>{copy('hero.description')}</p>
          <div className="hicps-hero-actions">
            {product.actions.map((action, index) => (
              <ContentAction key={action.label} action={action}
                className={index === 0 ? 'hicps-primary-button' : 'hicps-resource-button'}>
                {copy(`actions.${action.label}`)}
                <span aria-hidden="true">{action.external ? '↗' : '→'}</span>
              </ContentAction>
            ))}
          </div>
        </div>
      </section>
      {children}
    </main>
  );
}
